'use strict';exports.__esModule = true;exports.translateAndLowerCase = exports.getRoomsString = undefined;var _head = require('lodash/head');var _head2 = _interopRequireDefault(_head);
var _last = require('lodash/last');var _last2 = _interopRequireDefault(_last);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getRoomsString = exports.getRoomsString = function getRoomsString(params, translate) {
  if (!(0, _isEmpty2.default)(params.rooms)) {
    if (params.rooms.length === 1) {
      return (0, _head2.default)(params.rooms) + ' ' + translate('SEOsearch', 'rooms');
    }
    return (0, _head2.default)(params.rooms) + '-' + (0, _last2.default)(params.rooms) + ' ' + translate('SEOsearch', 'rooms');
  }
  return '';
};

var translateAndLowerCase = exports.translateAndLowerCase = function translateAndLowerCase(translate) {for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {params[_key - 1] = arguments[_key];}
  var translated = translate.apply(undefined, params);
  if (!(0, _isEmpty2.default)(translated)) {
    return translated.toLowerCase();
  }
  return '';
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/seo/commons.js
// module id = 1298
// module chunks = 0